import React from 'react';
import PropTypes from 'prop-types';

import {
  Input,
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { 
  MAXIMUM_SHORT_CODE_LENGTH, 
  InputKeys,
  KnowledgeMapColumnHeaders,
  KnowledgeMapIconIds,
  PRESENTATION_ROLE,
} from 'constants/knowledgeMap';
import { 
  InputHumanCodingScheme,
  InputHumanCodingSchemeWrapper, 
} from './styles';
import messages from './messages';

class ButtonHumanCodingScheme extends React.Component {
  state = {
    internalValue: this.props.value,
    showInput: false,
    duplicateShortCode: false,
    shortCodeInputLengthError: false,
  };

  handleOnClick = () => {
    this.setState({
      showInput: true,
      duplicateShortCode: false,
    });
  };

  handleOnChangeInput = (e) => {
    const {value} = e.target;
    const { knowledgeMap, knowledgeMapItemId } = this.props;
    this.setState({
      internalValue: value,
      shortCodeInputLengthError: value.length > MAXIMUM_SHORT_CODE_LENGTH ? true : false,
      duplicateShortCode: this.isDuplicateShortCode(knowledgeMap, value, knowledgeMapItemId),
    });
  };

  isDuplicateShortCode = (knowlegdeMap, inputCurrentValue, knowledgeMapItemId) => knowlegdeMap.items.some((item) =>
    (item.humanCodingScheme.toLowerCase().trim() === inputCurrentValue.toLowerCase().trim()) && (knowledgeMapItemId !== item.id));

  updateShortCode = () => {
    const { internalValue } = this.state;
    const { onUpdate } = this.props;

    this.setState({
      showInput: false,
    });

    if (onUpdate) {
      onUpdate(internalValue);
    }
  };

  isValidShortCode = () => {
    const { 
      shortCodeInputLengthError,
      duplicateShortCode,
      internalValue,
    } = this.state;
    return ((!shortCodeInputLengthError && 
      !duplicateShortCode) || 
      !(internalValue));
  }

  handleKeyDown = (event) => {
    if (event.key === InputKeys.ESCAPE_KEY) {
      this.handleShortCodeReset();
    }
    if (event.key === InputKeys.ENTER_KEY &&
       this.isValidShortCode()
    ) {
      this.updateShortCode();
    }
  };

  handleOnBlur = () => {
    this.handleShortCodeReset();
  };

  handleShortCodeReset = () => {
    this.setState({
      showInput: false,
      internalValue: this.props.value,
    });
  };

  handleMouseDown = (event) => {
    event.preventDefault();
  };

  renderErrorInfo = () => {
    const { shortCodeInputLengthError, duplicateShortCode, internalValue } = this.state;
    if(shortCodeInputLengthError){
      return intl.formatMessage(messages.shortCodeLengthError);
    } else if (duplicateShortCode && internalValue) {
      return intl.formatMessage(messages.duplicateShortCode);
    }

    return;
  }

  render() {
    const { value } = this.props;
    const { SUBMIT_INPUT, EDIT_INPUT, ADD_INPUT } = KnowledgeMapIconIds;
    const { showInput, internalValue } = this.state;
    const icon = value ? EDIT_INPUT : ADD_INPUT;

    return (
      <InputHumanCodingSchemeWrapper>
        {showInput ?
          <>
            <InputHumanCodingScheme>
              <Input
                labelHidden
                label={intl.formatMessage(messages.humanCodingSchemeLabel)}
                value={internalValue}
                placeholder={intl.formatMessage(messages.humanCodingSchemePlaceholder)}
                onChange={this.handleOnChangeInput}
                onKeyDown={this.handleKeyDown}
                onBlur={this.handleOnBlur}
                feedback={this.renderErrorInfo()}
                autoFocus />
              { this.isValidShortCode() ? <span role={PRESENTATION_ROLE} onMouseDown={this.handleMouseDown} onClick={this.updateShortCode}>
                <MaterialIcon id={SUBMIT_INPUT} />
              </span> : '' }
            </InputHumanCodingScheme>
          </> : 
          <Button chip onClick={this.handleOnClick} >
            <MaterialIcon left id={icon} />
            { value || KnowledgeMapColumnHeaders.SHORTCODE }
          </Button>}
      </InputHumanCodingSchemeWrapper>
    );
  }
}

ButtonHumanCodingScheme.propTypes = {
  value: PropTypes.string,
  onUpdate: PropTypes.func,
};

export default ButtonHumanCodingScheme;
